import React from 'react';
import { Button } from '@lifeomic/chroma-react/components/Button';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import { Text } from '@lifeomic/chroma-react/components/Text';
import surveyUrls from '@lifeomic/phc-web-toolkit/src/components/Surveys/util/surveyUrls';
import SurveyService from '@lifeomic/phc-web-toolkit/src/services/SurveyService';

export const clinicSurveyService = new SurveyService();

export const REOPEN_WARNING =
  'Reopening this completed response lets you correct it and complete it again. When you complete it, the clinic note in Elation is replaced. If a physician has signed that note, this removes the signature, and the corrected note goes back to Requiring Action for a new signature.';

export const reopenCompletedResponse = (
  response: fhir.QuestionnaireResponse,
  amendmentId: string,
): fhir.QuestionnaireResponse => {
  const extension = (response.extension || []).filter(
    item => item.url !== surveyUrls.surveyResponseAmendment,
  );
  extension.push({
    url: surveyUrls.surveyResponseAmendment,
    valueString: amendmentId,
  });
  return {
    ...response,
    status: 'in-progress',
    extension,
  };
};

export const ReopenCompletedSurveyDialog: React.FC<{
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}> = ({ isOpen, onCancel, onConfirm }) => (
  <Modal
    isOpen={isOpen}
    title="Reopen completed survey?"
    onDismiss={onCancel}
    actions={
      <>
        <Button variant="text" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm}>
          Reopen survey
        </Button>
      </>
    }
  >
    <Text>{REOPEN_WARNING}</Text>
  </Modal>
);
